import { Action, createReducer, on } from '@ngrx/store';
import { IPFSettingsCurrentFileResponse } from '../models/pf-settings-file.model';
import * as actions from '../actions';

export const getPFSettingsCurrentFileFeatureKey = 'getPFSettingsCurrentFile';
export interface PFSettingsCurrentFileState {
  loadPFSettingsCurrentFileResponse: IPFSettingsCurrentFileResponse[];
  loadPFSettingsCurrentFileResponseFailure: any;
  loaded: boolean;
}

export const initialState: PFSettingsCurrentFileState = {
  loadPFSettingsCurrentFileResponse: undefined,
  loadPFSettingsCurrentFileResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPFSettingsCurrentFile, (state, action) => ({
    ...state
  })),
  on(actions.loadPFSettingsCurrentFileSuccess, (state, action) => ({
    ...state,
    loadPFSettingsCurrentFileResponse: action.response,
    loaded: true
  })),
  on(actions.loadPFSettingsCurrentFileFailure, (state, action) => ({
    ...state,
    loadPFSettingsCurrentFileResponseFailure: action.error
  }))
);

export const getPFSettingsCurrentFileResponse = (state: PFSettingsCurrentFileState) => {
  if (state && state.loadPFSettingsCurrentFileResponse) return JSON.parse(JSON.stringify(state.loadPFSettingsCurrentFileResponse));
  else return null;
};

export const getPFSettingsCurrentFileIsLoaded = (state: PFSettingsCurrentFileState) => {
  state.loaded;
};
